import React from "react";
import styles from "../stylesERv2.module.scss";

const mesesAbrev = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

const mostrarFecha = (fechaStr) => {
  if (!fechaStr) return "Sin fecha";
  const [, month, day] = fechaStr.split("-");
  return `${day}-${mesesAbrev[parseInt(month) - 1]}`;
};

/**
 * Detalle de ingresos del header "B - Hardware" del ER v2 para un mes. Solo lectura.
 *
 * PASO 6 (reingeniería del EBITDA, 2026-10-07) — fuente única: `filas` llega YA calculada (un
 * elemento por negocio, agregando sus tramos del mes) desde `index.js`, con el MISMO
 * `montoLocal`/`RegistroFinancieroER` que ya suma la celda (`chileVentaLeavesSesion.registros["B
 * - Hardware"]` para Chile; `registrosHardware` directo para Perú, que no migra). El modal ya NO
 * recalcula `totalLocal` con `convertirAMonedaLocal` por su cuenta — "Total" = Σ `fila.totalLocal`
 * = la celda, por construcción. Antes de este paso, el modal reconstruía la lista de negocios con
 * `resolverNegociosHardwareDelMes` (proyección sobre `negocios_carteleria` cruda, documentada en
 * `estadoResultadosER.js:380-388` como NO equivalente a `registrosHardware`) y recalculaba cada
 * total con `convertirAMonedaLocal` — divergía de la celda en Chile 2026+ (ver doc de cierre,
 * ejemplo real feb-2026: celda $1.830.343 vs. suma de filas vieja $1.854.093).
 *
 * Se simplifica el desglose por fila a ID / Cliente-Edificio / Pantallas / Modalidad / Monto
 * original (moneda de catálogo) / Fecha factura / Total — se retira la columna "Valor UF/Dólar"
 * del v1 (cosmética, no aporta a la reconciliación modal==celda y su reconstrucción fiel desde
 * los 2 caminos de origen —el viejo y el vinculado a SII— no valía el riesgo).
 */
export const DetalleHardwareIngresosModal = ({
  isOpen,
  monthIndex,
  mesesCompletos,
  pais,
  moneda,
  localString,
  formatCurrency,
  filas = [],
  onClose,
}) => {
  if (!isOpen || monthIndex === null || monthIndex === undefined) return null;

  const total = filas.reduce((sum, f) => sum + (f.totalLocal || 0), 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContentComisionComercial} onClick={(e) => e.stopPropagation()}>
        <h3>Ingresos Hardware — {mesesCompletos[monthIndex]}</h3>
        <div style={{ overflowX: "auto" }}>
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>ID</th>
                <th style={{ textAlign: "left" }}>Cliente / Edificio</th>
                <th style={{ textAlign: "center" }}>Pantallas</th>
                <th style={{ textAlign: "center" }}>Modalidad</th>
                <th style={{ textAlign: "end" }}>Monto original</th>
                <th style={{ textAlign: "center" }}>Fecha factura</th>
                <th style={{ textAlign: "end" }}>Total {moneda(pais).trim()}</th>
              </tr>
            </thead>
            <tbody>
              {filas.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center", color: "#666" }}>
                    No hay ingresos de hardware en este mes.
                  </td>
                </tr>
              ) : (
                filas.map((f) => (
                  <tr key={f.id}>
                    <td style={{ textAlign: "center", fontWeight: 600 }}>{f.id}</td>
                    <td style={{ textAlign: "left" }}>{f.nombre}</td>
                    <td style={{ textAlign: "center" }}>{f.pantallas}</td>
                    <td style={{ textAlign: "center" }}>{f.modalidad}</td>
                    <td style={{ textAlign: "end" }}>
                      {(f.montoOriginal || 0).toLocaleString(localString(pais), {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      {f.moneda}
                    </td>
                    <td style={{ textAlign: "center" }}>{mostrarFecha(f.fecha)}</td>
                    <td style={{ textAlign: "end" }}>{formatCurrency(f.totalLocal, monthIndex)}</td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={6} style={{ textAlign: "end", fontWeight: 600 }}>
                  Total
                </td>
                <td style={{ textAlign: "end", fontWeight: 600 }}>{formatCurrency(total, monthIndex)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
